import { tierGuideForPlan } from "../../util/adsCopy";

const AdsTierCard = ({ isFreePlan = true }) => {
    const guide = tierGuideForPlan(isFreePlan);
    return (
        <section className="ads-card ads-tier-card" data-testid="ads-tier-card">
            <p className="ads-slot-kicker">What they buy</p>
            <h2>GOLD, SILVER, and BRONZE</h2>
            <p className="ads-card-lead">{guide.lead}</p>
            <div className="ads-tier-table-wrap">
                <table className="ads-tier-table">
                    <thead>
                        <tr>
                            <th>Tier</th>
                            <th>{guide.column}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {guide.rows.map((row) => (
                            <tr key={row.tier}>
                                <th scope="row">{row.tier}</th>
                                <td>{row.membersSee}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <ul className="ads-tier-notes">
                {guide.notes.map((note) => (
                    <li key={note}>{note}</li>
                ))}
            </ul>
        </section>
    );
};

export default AdsTierCard;
